module.exports = __webpack_public_path__ + "static/img/userguanli.03c360a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userguanli.gif
// module id = 7ZpB
// module chunks = 1